import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminLabelsNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('label');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
